<button mat-icon-button (click)="openPanel()" #tokenOrigin>
    <mat-icon [svgIcon]="'heroicons_solid:key'"></mat-icon>
</button>

<ng-template #tokenPanel>
    <div class="fixed inset-0 flex flex-col justify-center items-center bg-gray-50 p-8 overflow-hidden shadow-lg sm:static sm:inset-auto sm:w-90 sm:min-w-90 sm:rounded-2xl">
        <div class="flex shrink-0 items-center">
            <div class="-ml-1 mr-3 sm:hidden">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon class="text-current icon-size-5" [svgIcon]="'heroicons_mini:x-mark'"></mat-icon>
                </button>
            </div>
            <!-- BODY -->
             <div class="flex flex-col gap-y-4">
                <div class="flex flex-col justify-center items-center leading-none">
                    <span class="font-bold text-teal-600 text-2xl">GERADOR DE TOKEN</span>
                    <span class="mt-1.5 text-md font-medium text-center">Clique no botão abaixo para gerar um novo token</span>
                    <button mat-raised-button class="bg-teal-600 text-white font-bold mt-3" (click)="generateToken()">GERAR TOKEN</button>
                </div>
                @if(loading) {
                    <div class="flex flex-col justify-center items-center gap-y-3">
                        <span>Aguarde, gerando token...</span>
                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    </div>
                }
                @if(!loading && tokenResult.status) {
                    <div class="flex flex-col justify-center items-center">
                        <span class="text-secondary font-medium">TOKEN GERADO</span>
                        <span class="font-extrabold text-teal-600 text-4xl">{{ tokenResult.token }}</span>
                        <span class="text-secondary">{{ tokenResult.expiration_date }}</span>
                    </div>
                }
             </div>
        </div>
    </div>
</ng-template>
